import React, { useState } from 'react'
import { Button, Dropdown } from 'react-bootstrap'
import { Form } from 'react-bootstrap'
import { Col } from 'react-bootstrap'
import { Row } from 'react-bootstrap'
import { BsFillChatRightTextFill } from 'react-icons/bs'
import { createChat } from '../../Api/Chats/Chats'

interface InitializeChatProps {
    playerData: any;
    setSelectedChat: (chat: any) => void;
    setIsNewChat: (isNewChat: boolean) => void;
}

export const InitializeChat = ({ playerData, setSelectedChat, setIsNewChat }: InitializeChatProps) => {
    const emojis = ['😊', '😂', '👍', '❤️', '😎', '🎮', '💰', '✨', '🔥', '👋', '😅', '🙏', '💪', '🎯', '🌟'];
    const [showEmojis, setShowEmojis] = useState(false);
    const [inputMessage, setInputMessage] = useState('');

    const insertEmoji = (emoji: string) => {
        setInputMessage(prev => prev + emoji);
    };

    const sendMessage = async () => {
        const initialize = await createChat({
            message: inputMessage,
            type: 'text',
            creatorType: 'user',
            PlayerId: playerData?.id
        });
        if (initialize?.success &&initialize?.newChat?.id) {
            setSelectedChat(initialize?.newChat)
            setIsNewChat(false)
        }
    }

    return (
        <div className="border border-secondary rounded pt-4 h-100 ">

            <div className="mb-3 p-3 d-flex justify-content-center align-items-center" style={{ minHeight: "65vh", maxHeight: "65vh", overflowY: "auto", display: "flex", flexDirection: "column" }}>

                <div className="text-center text-primary">
                    <BsFillChatRightTextFill size={100} />
                    <div className='mt-3'>
                        <span>Escribe un mensaje para iniciar un chat con <span className='text-primaryy'>{playerData?.platformUser}</span></span>
                    </div>
                </div>

            </div>
            <hr />
            <Row className="mt-3 py-3">
                <Col xs={1}>
                    <Dropdown show={showEmojis} onToggle={(isOpen) => setShowEmojis(isOpen)} className="d-flex justify-content-center" >
                        <Dropdown.Toggle
                            variant="outline-secondary"
                            className="p-2 mm"
                            style={{ minWidth: '40px' }}
                        >
                            😊
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="bg-dark p-2" style={{ maxWidth: '200px' }}>
                            <div className="d-flex flex-wrap gap-2">
                                {emojis.map((emoji, index) => (
                                    <span
                                        key={index}
                                        role="button"
                                        onClick={() => insertEmoji(emoji)}
                                        style={{ fontSize: '20px' }}
                                    >
                                        {emoji}
                                    </span>
                                ))}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
                <Col xs={8}>
                    <Form.Control
                        type="text"
                        placeholder="Escribe un mensaje..."
                        value={inputMessage}
                        onChange={(e) => setInputMessage(e.target.value)}
                        className="text-light py-2"
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                sendMessage();
                            }
                        }}
                    />
                </Col>
                <Col xs={3}>
                    <Button variant="primary" onClick={sendMessage} className="w-100">
                        Enviar
                    </Button>
                </Col>
            </Row>
        </div>
    )
}
